import React from "react";
import { Input,Form } from "antd";
import BaseComponent from "../../redare/components/BaseComponent";


export default class UserPwdFormContent extends BaseComponent {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div>
                <Form ref={(o)=>this.form=o} className="add-form margin-bottom" labelAlign='right' labelCol={{span: 4}} wrapperCol={{span: 18}}>
                    <Form.Item label="新密码" name="pwd" rules={[{required: true, message: '请输入新密码'}]}>
                        <Input.Password placeholder="请输入" autoComplete="off"/>
                    </Form.Item>
                    <Form.Item label="密码确认" name="pwd1" rules={[{required: true, message: '再次输入密码'}]}>
                        <Input.Password placeholder="请输入" autoComplete="off"/>
                    </Form.Item>
                </Form>
            </div>
        )
    }
}